<template>
  <div>
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="xhname">
            <el-input placeholder="型号" v-model="searchForm.xhname" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="xhname_ct">
            <el-input placeholder="型号包含" v-model="searchForm.xhname_ct" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="xhname_nct">
            <el-input placeholder="型号不包含" v-model="searchForm.xhname_nct" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="source">
            <el-input placeholder="请输入品牌" v-model="searchForm.source" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="gongyingshang">
            <el-input placeholder="请输入供应商" v-model="searchForm.gongyingshang"
                      @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <div class="custom-table search-table">
      <el-table border fit highlight-current-row class="customer-table" :data="list" v-loading="listLoading">
        <el-table-column label="ID" prop="id" width="80"></el-table-column>
        <el-table-column label="型号" prop="xhname" width="200"></el-table-column>
        <el-table-column label="品牌" prop="source"  width="200"></el-table-column>
        <el-table-column label="库存数量" prop="number"></el-table-column>
        <el-table-column label="供应商" prop="gongyingshang" width="300"></el-table-column>
        <el-table-column label="库存版本" prop="version"></el-table-column>
        <el-table-column label="原币种" prop="currency"></el-table-column>
        <el-table-column label="原币价格" prop="price" ></el-table-column>
        <el-table-column label="成本价格" prop="cost_price"></el-table-column>
        <el-table-column label="销售价格" prop="selling_price"></el-table-column>
        <el-table-column label="货期" prop="hq"></el-table-column>
        <el-table-column label="上传日期" prop="upload_date" width="120"></el-table-column>
        <el-table-column label="备注" prop="bz" width="120"></el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                     :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                     :page-size="selectPage.pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                     style="margin-top: 14px;margin-bottom:14px"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {computed, defineComponent, onMounted, reactive, ref} from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue';
import request from '@/utils/request';
import waves from '@/directive/waves'

export default defineComponent({
  name: 'inventoryQuery',
  components: {PageWrapper},
  directives: {waves},
  setup() {
    const searchFormRef = ref(null)
    const searchForm = reactive({
      xhname:'',
      xhname_ct: '',
      xhname_nct:'',
      source: '',
      gongyingshang:'',
    })
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const list = ref([])
    const listLoading = ref(false)


    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const getList = () => {
      listLoading.value = true
      request({
        url: 'overseas_inventory_list.yy',
        method: 'post',
        params: selectPage,
        data: searchForm
      }).then(res => {
        const {code, data, total} = res
        if (code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
        }
      })
    }

    onMounted(() => {
      getList()
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getList()

    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getList()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getList()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getList()
    }


    return {
      list,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      listLoading,
      searchFormRef,
      pageSizeChange,
      pageCurrentChange,
      closeSearch,
      handleSearchBtn,
      handleResetBtn
    };
  }
})
</script>
<style scoped lang="scss">
.custom-table {
  padding: 20px;

  .customer-table {
    margin-top: 20px;
  }
}

</style>
